
const moment = require("moment-timezone");
export const convertTimeToUTC = (dateTimeString) => {
  return  moment.utc(dateTimeString, "DD-MM-YYYY HH:mm").format("YYYY-MM-DD HH:mm")
}
